/**
 * Shopping list categories for ingredients
 */
export const SHOPPING_CATEGORIES = {
  dairy: "Dairy & Eggs",
  meat: "Meat & Poultry",
  seafood: "Seafood",
  produce: "Fruits & Vegetables",
  grains: "Grains & Bread",
  pantry: "Pantry & Condiments",
  spices: "Spices & Seasonings",
  nuts: "Nuts & Seeds",
  oils: "Oils & Vinegars",
  beverages: "Beverages",
  frozen: "Frozen Foods",
  snacks: "Snacks",
  other: "Other",
};

export const SHOPPING_CATEGORY_OPTIONS = Object.entries(
  SHOPPING_CATEGORIES,
).map(([value, label]) => ({
  value,
  label,
}));

/**
 * Default category mapping for common ingredient names
 * This helps AI auto-categorization
 */
export const DEFAULT_CATEGORY_MAPPING = {
  // Dairy & Eggs
  milk: "dairy",
  cheese: "dairy",
  yogurt: "dairy",
  butter: "dairy",
  cream: "dairy",
  egg: "dairy",
  eggs: "dairy",

  // Meat & Poultry
  chicken: "meat",
  beef: "meat",
  pork: "meat",
  turkey: "meat",
  lamb: "meat",
  bacon: "meat",
  sausage: "meat",
  ground: "meat",

  // Seafood
  salmon: "seafood",
  tuna: "seafood",
  shrimp: "seafood",
  cod: "seafood",
  fish: "seafood",

  // Produce
  apple: "produce",
  banana: "produce",
  orange: "produce",
  spinach: "produce",
  lettuce: "produce",
  tomato: "produce",
  onion: "produce",
  carrot: "produce",
  broccoli: "produce",
  avocado: "produce",

  // Grains & Bread
  bread: "grains",
  rice: "grains",
  pasta: "grains",
  quinoa: "grains",
  oats: "grains",
  flour: "grains",

  // Nuts & Seeds
  almond: "nuts",
  walnut: "nuts",
  peanut: "nuts",
  cashew: "nuts",
  seed: "nuts",

  // Oils
  oil: "oils",
  vinegar: "oils",

  // Spices & Seasonings
  salt: "spices",
  pepper: "spices",
  garlic: "spices",
  cinnamon: "spices",
  oregano: "spices",
  basil: "spices",
  paprika: "spices",
};

/**
 * Automatically determine category for an ingredient based on its name
 * @param {string} ingredientName - The name of the ingredient
 * @returns {string} - The suggested category
 */
export const suggestCategory = (ingredientName) => {
  if (!ingredientName) return "other";

  const name = ingredientName.toLowerCase();

  // Check for exact matches or partial matches
  for (const [keyword, category] of Object.entries(DEFAULT_CATEGORY_MAPPING)) {
    if (name.includes(keyword)) {
      return category;
    }
  }

  return "other";
};
